<template>
  <div class="footer__info">
    <div class="row">
      <div class="col-6 col-md-3">
        <a href="http://ajuda.lelis.com.br/category/4/article/4/">
          <img src="../assets/lelis/icon_footer_1_new.png" />
          <p>ENTREGA EXPRESSA</p>
          <small> Compre e receba <br>no mesmo dia* </small>
        </a>
      </div>
      <div class="col-6 col-md-2">
        <a href="https://lkt.bio/lelisblancshopby">
          <img src="../assets/lelis/icon_footer_6_new.png" />
          <p>COMPRE PELO WHATSAPP</p>
          <small>Receba em Casa ou <br>Retire na Loja</small>
        </a>
      </div>
      <div class="col-6 col-md-2">
        <a href="https://lkt.bio/lelisblanc.evendedores">
          <img src="../assets/lelis/icon_footer_4_new.png" />
          <p>E-vendedoras</p>
          <small>Conte com o nosso <br>time de especialistas</small>
        </a>
      </div>

      <div class="col-6 col-md-2">
        <a href="https://www.lelis.com.br/regulamentos">
          <img src="../assets/lelis/icon_footer_3_new.png" />
          <p>FRETE GRÁTIS</p>
          <small>Nas compras<br> acima de R$ 600</small>
        </a>
      </div>
      <div class="col-12 col-md-3">
        <a href="http://ajuda.lelis.com.br/category/4/article/2/">
          <img src="../assets/lelis/icon_footer_5_new.png" />
          <p>PICK UP STORE</p>
          <small>Compre online e<br> retire na Loja*</small>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LelisFooter",
};
</script>

<style lang="scss">
.footer__info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 45px;
  margin: 0 auto;
  border-bottom: 1px solid #707070;
  .row {
    width: 100%;
  }
  a {
    color: #000;
    &:hover{
        color: #000;
    }
    img {
      max-height: 60px;
      @media(max-width: 1024px) {
        max-height: 50px;
      }
    }
    p {
      font-size: 13px;
      text-decoration: underline;
      // min-height: 38px;
      font-weight: 900;
      text-decoration: none;
      text-transform: uppercase;
      margin-top: 10px;
      @media(max-width: 1024px) {
        font-size: 11px;
        white-space: nowrap;
      }
    }
    small {
      display: block;
      font-size: 10px;
      margin: 0 auto 30px;
      line-height: 12px;
      margin-top: 10px;
      text-transform: uppercase;
    }
  }
}
</style>